import {Component, OnDestroy, OnInit} from '@angular/core';
import {BaseComponent} from '../../core/component/base.component';
import {PurchaseRequest} from '../../model/purchase-request';
import {PurchaseRequestLine} from '../../model/purchase-request-line';
import {PurchaseRequestFilter} from '../../filter/purchase-request.filter';
import {PurchaseRequestService} from '../../service/purchase-request.service';
import {AlertService} from '../../core/service/alert.service';
import {MessageService} from '../../core/service/message.service';
import {Router} from '@angular/router';
import {SecurityService} from '../../core/service/security.service';
import {LoggerService} from '../../service/logger.service';
import {AccountService} from '../../service/account.service';
import {Account, AccountType} from '../../model/account';

@Component({
    selector: 'app-purchase-request',
    templateUrl: './purchase-request.component.html',
    standalone: false
})
export class PurchaseRequestComponent extends BaseComponent<PurchaseRequest> implements OnInit, OnDestroy {

  budgetAccounts: Account[] = [];
  searchText = '';

  constructor(private purchaseRequestService: PurchaseRequestService,
              private alertService: AlertService,
              protected messageService: MessageService,
              protected loggerService: LoggerService,
              protected router: Router,
              protected securityService: SecurityService,
              private accountService: AccountService) {
    super(purchaseRequestService, 'purchaseRequest', alertService, router, securityService, messageService, loggerService);
    this.sortBy.push('consecutive');
    this.sortOrder = 'asc';
  }

  getModelInstance(): PurchaseRequest {
    const pr = new PurchaseRequest();
    pr.lines = [new PurchaseRequestLine()];
    return pr;
  }

  addLine(): void {
    if (!this.model.lines) {
      this.model.lines = [];
    }
    this.model.lines.push(new PurchaseRequestLine());
  }

  removeLine(index: number): void {
    this.model.lines.splice(index, 1);
    this.calculateTotal();
  }

  calculateTotal(): void {
    this.model.totalAmountToCommit = this.model.lines.reduce((acc, line) => acc + (line.amountToCommit || 0), 0);
  }

  clearFormErrors(): Map<string, string> {
    return new Map<string, string>();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.accountService.getClientAccountsWithExactLevel([], undefined,5, 'description', AccountType.BUDGET).subscribe(
      {
        next: (v) => this.budgetAccounts = v,
        error: (e) => this.processError(e)
      }
    );
  }

  getPageEvent(pageNumber: number, refresh: boolean = false): void {
    const filter = this.buildFilter();
    this.loading = true;
    this.purchaseRequestService.searchByFilter(filter, pageNumber, this.pageSize, this.sortBy, this.sortOrder)
      .subscribe({
        next: page => this.setPageEvent(page),
        error: err => this.processError(err)
      });
  }

  searchEvent(): void {
    this.getPageEvent(0, true);
  }

  private buildFilter(): PurchaseRequestFilter {
    const filter = new PurchaseRequestFilter();
    if (this.searchText && this.searchText.trim().length > 0) {
      filter.text = this.searchText.trim();
    }
    return filter;
  }

  getAccountDescription(id?: number): string {
    const account = this.budgetAccounts.find(a => a.id === id);
    return account ? `${account.code}` : id?.toString() || '';
  }

  downloadDocument(id?: number): void {
    if (id) {
      this.loading = true;
      this.purchaseRequestService.getDocument(id).subscribe({
        next: (blob) => {
          this.loading = false;
          this.triggerBlobDownload(blob, `CERTIFICACIÓN-DE-CONTENIDO-PRESUPUESTARIO-${id}.docx`);
        },
        error: (error) => this.processError(error)
      });
    }
  }
}
